import { Checkbox, Stack, TableCell, TableRow } from "@mui/material";
import { types } from "api";
import { StyledButton } from "components/StyledButton";
import { Link } from "react-router-dom";
import { getPath, routes } from "routes";
import React from "react";

export interface ViewGroupsPageTableRowProps {
	selected: string[];
	onCheckboxClick: (event: React.MouseEvent<unknown>, userid: string) => void;
	row: types.Group;
	labelId: string;
}

// const PREFIX = "GroupTableRow";

export const GroupTableRow = ({
	selected,
	row,
	onCheckboxClick,
	labelId,
}: ViewGroupsPageTableRowProps): JSX.Element => {
	const isSelected = (userid: string): boolean =>
		selected.indexOf(userid) !== -1;

	const isItemSelected = isSelected(row.groupId);
	return (
		<TableRow hover role="checkbox" key={row.groupId}>
			<TableCell padding="checkbox">
				<Checkbox
					checked={isItemSelected}
					data-testid="checkbox"
					inputProps={{ "aria-labelledby": labelId }}
					onClick={(event) => onCheckboxClick(event, row.groupId)}
				/>
			</TableCell>
			<TableCell data-testid="groupName">
				<Stack direction="row" alignItems="center">
					{row.name}
				</Stack>
			</TableCell>
			<TableCell data-testid="lastName">{row.students.length}</TableCell>
			<TableCell data-testid="edit-action">
				<StyledButton
					variant="contained"
					color="primary"
					sx={{ marginRight: 2 }}
					component={Link}
					to={getPath(routes._.result._.Groups._.viewGroup, {
						groupId: row.groupId,
					})}
				>
					STUDENT LIST
				</StyledButton>
				<StyledButton
					variant="contained"
					color="primary"
					sx={{ marginRight: 2 }}
					component={Link}
					to={getPath(routes._.result._.Groups._.viewGroupResult, {
						groupId: row.groupId,
					})}
				>
					VIEW REPORT
				</StyledButton>
			</TableCell>
		</TableRow>
	);
};
